import { Directive, ElementRef, OnInit, inject, input } from '@angular/core';

type ErrorType = 'required' | 'email' | 'minlength' | 'maxlength' | 'min' | 'max' | 'xmin' | 'xmax';

@Directive({
  standalone: true,
  selector: '[emError]'
})
export class ErrorDirective implements OnInit {

  private readonly element: ElementRef = inject(ElementRef);

  readonly type = input.required<ErrorType>({ alias: "emError" });

  readonly min = input<number>();

  readonly max = input<number>();

  readonly xmin = input<number>();

  readonly minlength = input<number>();

  readonly maxlength = input<number>();

  constructor() { }

  ngOnInit(): void {
    switch (this.type()) {
      case 'required':
        this.element.nativeElement.innerHTML = 'This field is required.';
        break;
      case 'email':
        this.element.nativeElement.innerHTML = 'Value must be a valid email.';
        break;
      case 'min':
        this.element.nativeElement.innerHTML = `Value shouldn't be less than ${this.min()}.`;
        break;
      case 'max':
        this.element.nativeElement.innerHTML = `Value shouldn't be greater than ${this.max()}.`;
        break;
      case 'xmin':
        this.element.nativeElement.innerHTML = `Value should be greater than ${this.xmin()}.`;
        break;
      case 'minlength':
        this.element.nativeElement.innerHTML = `This field must be at least ${this.minlength()} characters long.`;
        break;
      case 'maxlength':
        this.element.nativeElement.innerHTML = `This field must be maximum ${this.maxlength()} characters long.`;
        break;
    }
  }

}
